import { tracking } from '@iwoca/frontend-tracking-library';
import DocumentRequirement from '../DocumentRequirement';
import { TGetProductOffersResponseData } from '../TradingHistory';
import { getCurrentPathname } from '@iwRouter/LocationHelper';
import { Link } from '@iwoca/orion';

type TProps = {
    isOptional: boolean;
    isSubmitted: boolean;
    status?: TGetProductOffersResponseData['products'][number]['data_requirements'][number]['status'];
};
const CompanyAccounts = ({ isOptional, status }: TProps) => {
    return (
        <DocumentRequirement
            title="Company accounts"
            documentType="business accounts"
            isOptional={isOptional}
            status={status}
        >
            <p>
                Your last set of filed accounts, in a PDF format. This should be
                the full version of the accounts including profit and loss and
                balance sheet, broken down by item.{' '}
                <Link
                    href="https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() =>
                        tracking.ampli.externalLinkClicked({
                            category: 'Optional document: Company accounts',
                            'CTA destination': 'Company accounts guide',
                            'CTA URL':
                                'https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/',
                            'CTA text': 'Learn more',
                            'Page name': 'Application pending view',
                            URL: getCurrentPathname()
                        })
                    }
                >
                    Learn more
                </Link>
            </p>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default CompanyAccounts;
